export default "__VITE_ASSET__CeyvTTAX__"